/**
 * 活动信息
 */
import http from '../../base/http';

class Activity {

    constructor({ url = '' } = {}) {
        this.url = url;
        this.actData = {}; // 存储用户信息 {活动ID：活动信息}
    }

    getData() {
        let promise = $.Deferred();
        let params = {};

        let promiseGetData = http.fetch({
            url: this.url
        });


        promiseGetData.done((res) => {
            if (res.errcode == 0) {
                this.parseData(res.data);
                promise.resolve(this.actData);
            } else {
                promise.reject();
            }
        });

        promiseGetData.fail(() => {
            promise.reject();
        });

        return promise;
    }

    parseData(data) {

        if (data.list) {
            data.list.forEach((item, index) => {
                if (!this.actData[item.id]) {
                    item.serverTime = data.serverTime;
                    this.actData[item.id] = this.parseActData(item);
                }
            })
        } else {
            this.actData[data.id] = this.parseActData(data);
        }
    }

    parseActData(data) {
        let self = this;
        let today = data.serverTime;
        let gift = data.gift;
        let giftMap = {};
        let zb = data.periodList[0];
        let rb = data.periodList.slice(1);

        let currentDay;

        for (let i = gift.length - 1; i >= 0; i--) {
            let item = gift[i];

            if (!giftMap[item.id]) {
                giftMap[item.id] = item;
            }
        }

        data.giftMap = giftMap;
        data.overallRanking = zb;
        data.dailyRanking = rb;

        if (rb.length > 0) {
            // 总榜 + 日榜
            rb.forEach(function(item, index) {
                item.index = index;
                item.name = 'day' + (index + 1);

                if (today >= item.startTime && today < item.endTime) {
                    currentDay = item;
                }
            });

            if (currentDay) {
                // 活动期间
                data.currentDay = currentDay;
                data.status = 1;
            } else {
                // 活动未开始。第一天
                if (today < rb[0].startTime) {
                    data.currentDay = rb[0];
                    data.status = 0;
                } else if (today > rb[rb.length - 1].endTime) {
                    // 活动已结束。最后一天
                    data.currentDay = rb[rb.length - 1];
                    data.status = 2;
                }
            }
        } else {
            // 仅总榜
            if (today < zb.startTime) {
                // 活动未开始
                data.status = 0;
            } else if (today > zb.endTime) {
                data.status = 2
            } else {
                data.status = 1;
            }
        }

        return data;
    }
}

module.exports = Activity;



// WEBPACK FOOTER //
// ./js/component/base/activity.js